import { PseudoElementSelector } from "./pseudo-element.js";
/**
 * {@link https://drafts.csswg.org/css-pseudo-4/#selectordef-grammar-error}
 */
export class GrammarError extends PseudoElementSelector {
    static of() {
        return new GrammarError();
    }
    constructor() {
        super("grammar-error");
    }
    *[Symbol.iterator]() {
        yield this;
    }
}
(function (GrammarError) {
    GrammarError.parse = PseudoElementSelector.parseNonLegacy("grammar-error", GrammarError.of);
})(GrammarError || (GrammarError = {}));
//# sourceMappingURL=grammar-error.js.map